module.exports = __webpack_public_path__ + "static/media/preview_earning_campaigns.5e4234ed.svg";